import React, { useState } from 'react';
import { Box, Typography, Avatar, IconButton, Menu, MenuItem, Grid, CircularProgress } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Delete, Edit, Hub } from '@mui/icons-material';

const RectangularCustomChipBots = ({ icon, title, caption, key, onClick, onEdit, onDelete,themeMode}) => {
  const [anchorEl, setAnchorEl] = useState(null);
const[deleting, setDeleting] = useState(false)
  const handleMenuOpen = (event) => {
    event.stopPropagation(); // Prevents triggering the Box onClick
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);

  };

  const handleEdit = () => {
    onEdit && onEdit();
    handleMenuClose();
  };

  const handleDelete = () => {
    onDelete && onDelete();
    handleMenuClose();
  };

  return (
    <Box
      key={key}
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 1,
        bgcolor: themeMode === 'dark'? '#414457' : 'background.paper',
        '&:hover': {
          boxShadow: 3,
        },
        minWidth:{sm:'49%', xs:'100%'},
        transition: 'box-shadow 0.3s ease-in-out',
      }}
    >
      <Grid container alignItems="center">
        <Grid item xs={11} onClick={onClick} sx={{ display: 'flex', cursor: 'pointer' }} alignItems="center">
          <Avatar variant="square" sx={{ bgcolor: 'primary.main', mr: 2, borderRadius: 3 }}>
            {icon || <Hub />}
          </Avatar>
          <Box>
            <Typography variant="subtitle2" fontWeight="bold">
              {title}
            </Typography>
          </Box>
        </Grid>

        {/* Separate Grid item for the IconButton */}
        <Grid item xs={1}>
          <IconButton onClick={handleMenuOpen} aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        </Grid>
      </Grid>

      {/* Edit/Delete Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleEdit}><Edit htmlColor='dodgerBlue' sx={{marginRight:1}}/> Edit</MenuItem>
        <MenuItem onClick={handleDelete}><Delete htmlColor='tomato' sx={{marginRight:1}}/> Delete </MenuItem>
      </Menu>
    </Box>
  );
};

export default RectangularCustomChipBots;
